module.exports = __webpack_public_path__ + "d00bf315d82d6325403d79062fd106fb.MP3";